<template>
    <div>
        <!-- HEADER FOR ALL CLUSTERS -->
        <h1>Communications Cluster 🎨</h1>
        <h4>The Communications Cluster is in charge of the overall branding and information dissemination of the organization. This includes promoting the organization’s events and services inside and outside MISA. The Communications Cluster is also responsible for determining the communication protocols of the organization and ensuring that these are properly observed.</h4>

        <h3>Positions:</h3>

        <!-- COMM POOL 
        <h2><b>Communications Cluster Creatives Pool</b></h2>
        <h4>The Communications Cluster Creatives Pool consists of the creative directors, video editors, and promotional strategists who will be deployed in internal and external initiatives of the organization. The creative directors and video editors will be managed by two AVP for Creatives, while the promotional strategists will be managed by the AVP for Promotional Strategy. As such, the officers will have the option to be deployed in internal or external initiatives as a creative.</h4>
        <h3> Positions: </h3>-->

        <h2><b>Creative Director</b></h2>
        <h4>The Creative Director is in charge of designing posters and other promotional materials for the event. They work with the project team in order to create promotional materials that aligns with the core team’s vision for the event. They also work closely with the Promotional Strategist to determine the overall look and peg of the event’s branding.</h4>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Contributes to the creative output of the project team by creating designs through posters, animations, prototypes, etc. that capture and concretize the theme of an activity, a project, or an event, while maintaining the consistency of MISA’s branding</li>
            <li>Required to create a proposed Visual Identity Proposal with a Promotional Strategist for their deployed event </li>
            <li>Sets the creative direction of the project or assignments </li>
        </ul>

        <h2><b>Promotional Strategist</b></h2>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Conceptualizes promotional strategy and timeline</li>
            <li>Creates spiels that accompany posters and promotional materials</li> 
            <li>Oversees non-traditional promotions and video/photo shoots</li>
            <li>Communicates with Creative Directors for needed promotional materials</li>
            <li>Sending Blast Requests through the Communications Cluster Blast Request Form</li>
            <li>Administers brainstorming sessions of the events they are deployed to with the supervision of the Associate Vice President for Promotional Strategy</li>
        </ul>

        <h2><b>Photographer</b></h2>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Documents events, projects, assignments through photos</li>
            <li>Post-processes and adds watermark to the photos he/she has taken</li>
            <li>Generates quality photos that will be blasted through the organization’s channels (e.g. Facebook, Twitter, etc.)</li>
            <li>Required to upload all raw and post-processed images and materials to the official Communications drive assigned to their event for archival and documentation purposes</li>
            <li>Must be available to attend on-campus for multiple occasions</li>
        </ul>

        <h2><b>Videographer</b></h2>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Documents events, projects, assignments through videos</li>
            <li>Post-processes videos he/she has taken</li>
            <li>Generates quality videos that will be blasted through the organization’s channels (e.g. Facebook, Twitter, etc.)</li>
            <li>Required to upload all raw and post-processed videos to the official Communications drive assigned to their event for archival and documentation purposes</li>
            <li>Must be available to attend on- for multiple occasions</li>
        </ul>
        
        <h2><b>Video Editor</b></h2>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Contributes to the creative output of the project team by creating designs through posters, animations, prototypes, etc. that capture and concretize the theme of an activity, a project, or an event, while maintaining the consistency of MISA’s branding.</li>
            <li>Required to create a proposed Visual Identity Proposal with a Promotional Strategist for their deployed event.</li>
            <li>Presents the Visual Identity Proposal to the Communications Core.</li>
            <li>Sets the creative direction of the project or assignments.</li>
            <li>Overall decision-maker on designs in project assigned to him/her.</li>
        </ul>

        <h2><b>Onsite Creatives</b></h2>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Responsible for arranging the logistics of onsite promotional materials</li>
            <li>Visualizes and implements venue setup and decoration during onsite events</li>
            <li>Assists and Works with Creative Directors to create the materials needed for promotional materials</li>
            <li>Conceptualizes and oversees venue decoration and planning</li>
            <li>Ensures that the venue is prepared and presentable on the day of the event</li>
            <li>Must be available to attend on-campus for multiple occasions</li>
        </ul>
        
        <h2><b>UI Designer</b></h2>
        <h4>Responsibilities:</h4>
        <ul>
            <li>The UI Designer is responsible for the user experience/user interface research and design in the website development of internal initiatives.</li>
            <li>Conceptualizes the visual direction in the website development of IM-related initiatives in collaboration with the eServices cluster.</li>
            <li>Generates prototypes, wireframes, mockups, and user journey maps that will be executed by the developers in their deployed projects</li>
            <li>Sets the creative direction of the project or assignments</li>
        </ul>

        <!-- POSITION -->
        <!-- <h2><b>Product Designer (2)</b></h2>
        <h4>The Product Designer is in charge of designing the user experience and user interface aspect of the Ateneo MISA’s website development for internal projects.</h4>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Responsible for the user experience/user interface research and design in the website development of internal projects.</li>
            <li>Creates wireframes and mockups for MISA’s website development in internal projects.</li>
            <li>Contributes in creating the user interface elements needed in the website.</li>
            <li>Works closely with the eServices Cluster to conceptualize the visual direction in the website development of IM-related initiatives.</li>
        </ul> -->

        <!-- BETA POSITIONS -->
        <!--<h2><b>Associate Vice President for Creatives and Publications (2)</b></h2>
        <h4>Responsibilities:</h4>

        <ul>
            <li>Oversees the creation of all visual identity and creative material for all publications and ensures the all materials created and utilized by the organization’s officers and members appropriately portray and adhere to MISA’s branding manual and code of internal procedures</li>
            <li>Facilitates design critique and review for creative projects and outputs, which entails giving comments or suggestions regarding any promotional deliverable for all MISA publication materials</li>
            <li>Assists the Vice President for Communications in consolidating and screening the organization’s publication request form</li>
            <li>Spearheads various trainings and workshops for skills related to creative work (such as design, photography, videography, design-thinking, etc.)</li>
            <li>Trains, oversees, deploys, and communicates with the third-level officers of the sub-cluster and serves as the bridge between the third-level officers and the Vice President for Communications</li>
        </ul>

        <h2><b>Associate Vice President for Promotional Strategy (1)</b></h2>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Oversees proper promotion of all the organization’s events and services and ensures that the promotions adhere to the code of internal procedures, and information is handled and disseminated responsibly within and outside the organization</li>
            <li>Conceptualizes effective promotional strategies and composes spiels for the events and initiatives of the organization and its clusters and compiles individual promotional timelines and makes sure that the promotional schedules are followed</li>
            <li>Assists the Vice President for Communications in consolidating and screening the organization’s blast request form and the blasting calendar</li>
            <li>Manages the organization’s active communication channels</li>
            <li>Ensures that members of the Board of Executives and the Associates participate in blasting promotional materials of the organization</li>
            <li>Trains, oversees, deploys, and communicates with the third-level officers of the sub-cluster and serves as the bridge between the third-level officers and the Vice President for Communications</li>
        </ul> -->

        <!-- FOOTNOTES? -->
        <br>
        <p></p>
    </div>
</template>

<script>
export default {
    name: 'PrimerComms'
}
</script>

<style scoped>
h1{
    font-size: 4.5vw;
}
</style>
